module.exports = __webpack_public_path__ + "img/white_logo.77c6e1b9.svg";